import React from 'react';
import { ClickableTile } from 'carbon-components-react';
import { Launch16 } from '@carbon/icons-react';

type Props = {
  handleOnClick: Function;
};

const Learn5Ps: React.FC<Props> = ({ handleOnClick }) => {
  const iconName = 'icon-5-p';
  return (
    <React.Fragment>
      <ClickableTile
        handleClick={() => {
          handleOnClick(
            'LearnAboutThe5PsOfSafeExcavation',
            `${process.env.REACT_APP_PROMO_LEARN_THE_5PS_URL}`
          );
        }}
        className="tile--clickable learn5psTile"
      >
        <div className="tile--clickable-logo">
          <img
            src={`../${iconName}.png`}
            className="dbyd-certification-logo"
            alt="dbyd-certification-logo"
          />
          <div className="tileHeader">
            <span>Learn about the 5Ps of safe excavation</span> <Launch16 />
          </div>
        </div>
      </ClickableTile>
    </React.Fragment>
  );
};

export default Learn5Ps;
